import { render } from "./Agenda.vue?vue&type=template&id=f494e024"
import script from "./Agenda.vue?vue&type=script&lang=ts"
export * from "./Agenda.vue?vue&type=script&lang=ts"
script.render = render

export default script